<micro-select-combo #sel
              placeholder="Voice Carrier Type"
              [mode]="mode"
              [(id)]="voiceCarrierTypeId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
